// extracted by mini-css-extract-plugin
module.exports = {"container":"FloatingButtonText_container__f3PRY","sticky":"FloatingButtonText_sticky__1YPd3"};